import React from 'react';
import { forwardRef } from '@hub/design-system-base';
import { Text } from '@hub/text';
import { Link, LinkBox, LinkOverlay } from '@hub/link';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { CloudinaryImage, IMAGE_SIZES_DECK_REEL } from '../cloudinary-image';
import MemberExclusiveLabel from '../../components/member-exclusive-label';
import { isMemberExclusive } from '../../helpers/is-member-exclusive';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InlineDeckItem = forwardRef((item, ref) => {
  const {
    image,
    title,
    shortDescription,
    displayDate,
    callToAction,
    sx,
    imageRef,
    as,
    onClick,
    highlightAttribute
  } = item;
  return /*#__PURE__*/_jsxs(LinkBox, {
    ref: ref,
    sx: sx,
    as: as,
    onClick: onClick,
    "data-id": "inline-deck_inline-deck-item_InlineDeckItem_LinkBox",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        position: 'relative'
      },
      "data-id": "inline-deck_inline-deck-item_InlineDeckItem_LinkBox_Box",
      children: [/*#__PURE__*/_jsx(CloudinaryImage, {
        ratio: "1",
        imageSetOrImage: image,
        imageRef: imageRef,
        sizes: IMAGE_SIZES_DECK_REEL,
        "data-id": "inline-deck_inline-deck-item_InlineDeckItem_Box_CloudinaryImage"
      }), /*#__PURE__*/_jsx(MemberExclusiveLabel, {
        sx: {
          position: 'absolute',
          width: '91px',
          bottom: 0
        },
        display: isMemberExclusive(highlightAttribute),
        option: "small",
        "data-id": "inline-deck_inline-deck-item_InlineDeckItem_Box_MemberExclusiveLabel"
      })]
    }), /*#__PURE__*/_jsxs(Stack, {
      gap: "spacing-xs",
      sx: {
        paddingTop: 'spacing-sm',
        paddingRight: 'spacing-sm'
      },
      "data-id": "inline-deck_inline-deck-item_InlineDeckItem_LinkBox_Stack",
      children: [/*#__PURE__*/_jsx(LinkOverlay, {
        href: callToAction.url,
        "data-id": "inline-deck_inline-deck-item_InlineDeckItem_Stack_LinkOverlay",
        children: /*#__PURE__*/_jsx(Text, {
          tone: "strong",
          "data-id": "inline-deck_inline-deck-item_InlineDeckItem_LinkOverlay_Text",
          children: title
        })
      }), shortDescription && /*#__PURE__*/_jsx(Text, {
        noOfLines: 2,
        "data-id": "inline-deck_inline-deck-item_InlineDeckItem_Text_7",
        children: shortDescription
      }), displayDate && /*#__PURE__*/_jsx(Text, {
        color: "quartz",
        "data-id": "inline-deck_inline-deck-item_InlineDeckItem_Text_8",
        children: displayDate
      }), !displayDate && !shortDescription && /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: callToAction.url,
        "data-id": "inline-deck_inline-deck-item_InlineDeckItem_Link",
        children: callToAction.label
      })]
    })]
  });
});